import { useEffect } from "react";
import { setTitlePage } from "../../Functions";

const Covenant = () => {

  useEffect(() => {
    setTitlePage('Convenios');
  }, [])


  const Automotriz = () => {
    return (
      <div className="accordion-item text-gray-600">
        <h2 className="accordion-header">
          <button className="accordion-button fs-4 fw-bold text-amsm collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            CONVENIO AUTOMOTRIZ
          </button>
        </h2>
        <div id="collapseOne" className={`accordion-collapse collapse`} data-bs-parent="#covenant">
          <div className="accordion-body">
            <div className="px-4">
              <p className="fs-5">AMSM es parte de la Federación Médica de Chile, la que ha suscrito acuerdos con Autokas y Alfa
                Romeo a los que nuestros asociados pueden acceder.</p>
              <p className="fs-5">En Autokas contempla descuento de hasta un 7% en modelos seleccionados en la compra de
                automóviles de variadas marcas como Fiat, Jeep, Ram, Dodge, Mitsubishi, Ssanyong, Exeed, Chery,
                Honda, JMC, GAC y Citroen.</p>

              <p className="fs-5">En Alfa Romeo, hay un beneficio exclusivo consistente en un 10% de descuento en la adquisición
                de los modelos Stelvio Veloce y Giulia Veloce. Los interesados pueden conocer estos vehículos en
                el showroom ubicado en Av. José Alcalde Délano 10501, en Lo Barnechea.
                Para acceder a los beneficios envíe un correo a <a href="mailto:contacto@federacionmedica.cl">contacto@federacionmedica.cl</a></p>

            </div>

          </div>
        </div>
      </div>
    )
  }

  const Sheraton = () => {
    return (
      <div className="accordion-item text-gray-600">
        <h2 className="accordion-header">
          <button className="accordion-button fs-4 fw-bold text-amsm collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            CONVENIO GIMNASIO HOTEL SHERATON
          </button>
        </h2>
        <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#covenant">
          <div className="accordion-body">
            <p className="fs-5">
              Nuestros asociados tienen la posibilidad de acceder al gimnasio del Hotel Sheraton abierto 24/7 a valores preferenciales en su Plan Trimestral (según el número de inscritos).
            </p>
            <p className="fs-5">
              5-25 miembros: $225.000 por Plan Trimestral (valor normal $255.000)<br />
              26-40 miembros: $216.000 por Plan Trimestral (valor normal $255.000)<br />
              Para inscripciones, dudas o consultas llamar al +(562) 2 27070177 o escribir a <a href="mailto:juancarlos.liberona@sheraton.com">juancarlos.liberona@sheraton.com</a>
            </p>

            <p className="fs-5">
              Otros planes:<br />
              Valor Mensualidad $ 85.000 IVA Incluido<br />
              Plan Semestral 10% de descuento ($ 510.000 / Valor final $ 459.000)<br />
              Plan Anual 15% de descuento ($ 1.020.000 / Valor final $ 867.000)<br />
              Valores incluyen matrícula
            </p>

            <p className="fs-5">Detalles</p>
            <ul className="fs-5">
              <li>Todos los Planes aplican descuento con Pago al Contado</li>
              <li>Uso liberado de Sauna y Piscina Temperada (no aplica piscina exterior). Horario (Spa y Piscina): lunes a sábado de 08.00 a 20.00 horas / Domingo 10.30 a 19.00 horas</li>
              <li>Los Planes Semestrales y Anuales obtendrán un 15% de descuento en Servicio de Masajes y Tratamientos</li>
              <li>Planes personales e intransferibles</li>
              <li>Acceso a clases con Personal Training, por un costo extra (consultar valores)</li>
              <li>Todo socio deberá firmar una Declaración Jurada de Salud</li>
              <li>Para planes anuales, se permite el congelamiento de 30 días</li>
              <li>Para planes Semestrales y Trimestrales, se permite el congelamiento de 15 días</li>
              <li>Para mensualidades, no se permite congelamiento            </li>
            </ul>

            {/* <p className="fs-5"><span className="fw-bold">Teléfono celular:</span> <a href="tel:+56992500579">+569 92500579</a></p> */}
          </div>
        </div>
      </div>
    )
  }

  const Isapre = () => {
    return (
      <div className="accordion-item text-gray-600">
        <h2 className="accordion-header">
          <button className="accordion-button fs-4 fw-bold text-amsm collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            PLAN MEDICO ISAPRE VIDA TRES
          </button>
        </h2>
        <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#covenant">
          <div className="accordion-body">
            <p className="fs-5">
              Isapre Vida Tres ha desarrollado una oferta de salud exclusiva para los médicos asociados de
              AMSM A.G., que considera:
            </p>
            <ul className="fs-5">
              <li>Planes con precios especiales</li>
              <li>Prestador preferente Clínica Santa María</li>
              <li>Coberturas especiales sin tope</li>
              <li>Beneficio a elección de descuento en farmacia o atención dental</li>
              <li>Seguros adicionales</li>
            </ul>
            <p className="fs-5">
              Vida Tres dispone ejecutiva para su atención y asesoría personalizada, sus datos de contacto son:<br />
              Asesora de Salud y Gestión: Macarena Arancibia<br />
              Mail: <a href="mailto:marancibia@vidatres.cl">marancibia@vidatres.cl</a><br />
              Fono: <a href="tel:+56986887989">+56 9 8688 7989</a>
            </p>
          </div>
        </div>
      </div>
    )
  }

  const Seguro = () => {
    return (
      <div className="accordion-item text-gray-600">
        <h2 className="accordion-header">
          <button className="accordion-button fs-4 fw-bold text-amsm collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
            SEGURO DE RENTA MEDICA
          </button>
        </h2>
        <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#covenant">
          <div className="accordion-body">
            <p className="fs-5">
              <strong>Compañía HDI Seguros</strong><br />
              <strong>Asegurados:</strong> Socios de Asociación Gremial Médicos Clínica Santa María A.G.
              <strong>Cobertura Base:</strong> 680 UF por evento, períodos de 4 meses (170 UF mensual).
              <ul>
                <li>Accidentes fortuitos, incapacidad temporal a causa de colelitiasis o urolitiasis, apendicitis,
                  peritonitis.</li>
                <li>Enfermedades de etiología infecciosa primaria o coronaria aguda con infarto del miocardio en
                  evolución, y las consistentes en accidentes cerebro vasculares agudos hemorrágicos o
                  trombóticos.</li>
              </ul>

              <strong>Cobertura Complementaria</strong> (50% de la cobertura base)
              <ul>
                <li>340 UF por evento, períodos de 4 meses (85UF mensual).</li>
                <li>Incapacidad temporal a causa de enfermedades oncológicas.</li>
                <li>Accidentes derivados del ejercicio de la profesión, cortaduras o quemaduras producto de cirugía o tratamiento a pacientes.</li>
                <li>En caso de Covid-19 cobertura 85 UF tope por dos meses.</li>
              </ul>

              Deducible 10 días desde la fecha de licencia médica, entre el día 11 y el 29 se paga porcentual
              incremental de la cobertura, siendo el 100% a contar del día 30.<br/>
              En caso de Covid-19 y patologías asociadas, a partir del segundo denuncio de siniestro tendrá una
              carencia de 20 días.<br/><br />
              Para más información consulte en <a href="mailto:informaciones@amsm.cl">informaciones@amsm.cl</a>
            </p>
          </div>
        </div>
      </div>
    )
  }

  const Complementario = () => {
    return (
      <div className="accordion-item text-gray-600">
        <h2 className="accordion-header">
          <button className="accordion-button fs-4 fw-bold text-amsm collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
            SEGURO COMPLEMENTARIO DE SALUD
          </button>
        </h2>
        <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#covenant">
          <div className="accordion-body">
            <p className="fs-5">
              <strong>Compañía de Seguros VIDA CAMARA.</strong> Salud - Dental - Catastrófico - Vida<br/>
              <strong>Asegurados: </strong>Socios de Asociación Gremial Médicos Clínica Santa María A.G., cónyuge e hijos menores de 25 años.<br/><br/>
              <strong>Coberturas</strong><br/>

              <ul>
              <li>Complemento de Salud: tope anual UF 350</li>
              <li>Dental: tope anual UF 15</li>
              <li>Medicamentos: tope anual UF 10</li>
              <li>Catastrófico: tope inicial anual UF 500</li>
              <li>Máximo anual UF 3.000, con formulario incorporación, hasta 69 años</li>
              </ul>

              <br/><strong>Beneficios adicionales</strong><br/>
              
              <ul>
              <li>Reembolso en línea de medicamentos en Farmacias Cruz Verde</li>
              <li>Gastos ambulatorios liberados de solicitud de reembolso</li>
              <li>Reembolso vía transferencia electrónica de fondos por parte de Vida Cámara</li>
              <li>Atención preferencial de ejecutivo Corredora de Seguros</li>
              </ul>
              
              <br/><strong>Principales exclusiones</strong><br/>
              Cualquier prestación médica para fines preventivos y/o estéticos, gastos a consecuencia de
              embarazos cuya concepción sea anterior a la vigencia de la titular mujer o cónyuge de un titular
              incorporado en la póliza, productos dermatológicos.<br/><br/>

              Para más información consulte en <a href="mailto:informaciones@amsm.cl">informaciones@amsm.cl</a>
            </p>
          </div>
        </div>
      </div>
    )
  }  

  return (
    <div className="card px-5 py-4">
      <div className="row">
        <div className="col-12 px-4 py-5">

          <div className="accordion" id="covenant">
            <Automotriz />
            <Sheraton />
            <Isapre />
            <Seguro />
            <Complementario />
          </div>

        </div>
      </div>
    </div>
  )
}

export default Covenant